// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#status[data-v-2a08f875]{position:fixed;top:1px;right:3px;font-size:12px;cursor:default;transition:1s}#status[data-v-2a08f875]:hover{transition:.1s;opacity:1}.pinned[data-v-2a08f875]{opacity:1}.notPinned[data-v-2a08f875]{opacity:0}.on[data-v-2a08f875]{color:#adff2f}.off[data-v-2a08f875],.on[data-v-2a08f875]{font-weight:700;background-color:#555;border-radius:5px;padding-left:8px;padding-right:8px}.off[data-v-2a08f875]{color:salmon}", ""]);
// Exports
module.exports = exports;
